export default __webpack_public_path__ + "static/media/grafiken_memory_666x666_mit_rand_M1_01.ecb3232c.jpg";